export default __webpack_public_path__ + "static/media/css.809ecbb3.png";